__turbopack_context__.v({
  "customerSaysRow": "TestimonialCard-module-scss-module__dt3LgW__customerSaysRow",
  "imgBox": "TestimonialCard-module-scss-module__dt3LgW__imgBox",
  "textCol": "TestimonialCard-module-scss-module__dt3LgW__textCol",
});
